import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import moment from 'moment';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router';
import { FE_DATE_TIME_FORMAT, INDICATION_REQUEST_STATUS, some } from 'modules/common/constants';
import SupplyOrder from 'modules/common/modules/supply/SupplyOrder';
import ParticipantTab from 'modules/labDoctor/component/detail/participant/ParticipantTab';
import PatientInfoBox from 'modules/labDoctor/component/detail/testService/PatientInfoBox';
import { useFetch } from 'modules/common/hook';
import { API_SERVER } from 'modules/common/api';
import TestServiceTab from '../component/detail/testService/TestServiceTab';

const TAB_MENUS = [{ id: 'experiment' }, { id: 'participant' }, { id: 'supply.title' }];

interface Props {}

const LabDoctorIndicationDetail: React.FunctionComponent<Props> = (props) => {
  const [tabValue, setTabValue] = React.useState(0);
  const { indicationRequestId } = useParams<{ indicationRequestId }>();
  const { data: indicationRequest } = useFetch(API_SERVER.indicationRequest.get(indicationRequestId));
  const { data: encounter } = useFetch(API_SERVER.encounter.get(indicationRequest?.referenceId!), {
    enabled: indicationRequest && indicationRequest?.referenceId,
  });
  const readOnly = React.useMemo(() => {
    return (
      (indicationRequest?.status === INDICATION_REQUEST_STATUS.FINISHED.value &&
        indicationRequest?.endTime?.isBefore(moment().subtract(1, 'day'))) ||
      indicationRequest?.status === INDICATION_REQUEST_STATUS.CANCELLED.value
    );
  }, [indicationRequest?.endTime, indicationRequest?.status]);

  return (
    <Paper elevation={1} style={{ overflow: 'auto', position: 'relative', flex: 1 }}>
      <Box bgcolor={'white'} borderBottom={`1px solid ${grey[400]}`}>
        <Box padding={2} paddingBottom={1}>
          <PatientInfoBox data={encounter} indicationRequest={indicationRequest} />
        </Box>
        <Box paddingX={2}>
          <Typography variant="h6" color="primary">
            {encounter?.patient?.name}
            &emsp;-&emsp;
            <Typography variant="subtitle1" color="textSecondary" component="span">
              <FormattedMessage id="indicationDate" />
              &nbsp;
              {indicationRequest && moment(indicationRequest?.createdTime).format(FE_DATE_TIME_FORMAT)}
            </Typography>
          </Typography>
          <Typography variant="body2" marginTop={1}>
            <FormattedMessage id="reason" />
            :&nbsp;
            <Typography variant="body2" component="span">
              {encounter?.reason}
            </Typography>
          </Typography>
        </Box>
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => {
            setTabValue(newValue);
          }}
          variant="scrollable"
          indicatorColor="secondary"
          textColor="secondary"
          style={{ padding: '0px 8px' }}
        >
          {TAB_MENUS.map((tab: some, index: number) => {
            return (
              <Tab
                key={index}
                value={index}
                style={{ minWidth: 100 }}
                label={
                  <Typography variant="subtitle2">
                    <FormattedMessage id={tab.id} />
                  </Typography>
                }
              />
            );
          })}
        </Tabs>
      </Box>
      <Box padding={2} overflow="auto">
        <div style={{ display: tabValue === 0 ? 'unset' : 'none' }}>
          <TestServiceTab indicationRequest={indicationRequest} revalidateIndicationList={() => {}} />
        </div>
        <div style={{ display: tabValue === 1 ? 'unset' : 'none' }}>
          <ParticipantTab data={indicationRequest} readOnly={readOnly} />
        </div>
        <div style={{ display: tabValue === 2 ? 'unset' : 'none' }}>
          <SupplyOrder indicationRequest={indicationRequest} readOnly={readOnly} encounter={encounter} />
        </div>
      </Box>
    </Paper>
  );
};

export default LabDoctorIndicationDetail;
